module.exports = __webpack_public_path__ + "img/contact-p.c5e52d8a.png";